import React from 'react';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';
import { Text, TextType } from 'ui-components/components/text';

import { PHONE_VERIFICATION_STATES } from '../../../../authentication/constants';
import { getDisplayForFactor } from '../../helpers';
import messages from '../../messages';
import ErrorBanner from '../components/error-banner';

/**
 * @typedef {import('../../api').MfaEnrollment} MfaEnrollment
 * @typedef {import('../../api').StartMfaChallengeRes} StartMfaChallengeRes
 */

/**
 * @param {object} props
 * @param {MfaEnrollment[]} props.enrollments
 * @param {string} props.selectedEnrollmentId
 * @param {(arg0: string) => void} props.setSelectEnrollmentId
 * @param {null|{ code: string, message: string }} [props.error]
 * @param {string} [props.phoneVerificationState]
 * @returns {JSX.Element}
 */
export const ChoosePhaseBody = ({ enrollments, error, phoneVerificationState, selectedEnrollmentId, setSelectEnrollmentId }) => {
  const shouldShowForcedMfaContext =
    phoneVerificationState === PHONE_VERIFICATION_STATES.BANNER ||
    phoneVerificationState === PHONE_VERIFICATION_STATES.MODAL ||
    phoneVerificationState === PHONE_VERIFICATION_STATES.UNSKIPPABLE;

  return (
    <FlexColumn gap={Gap.Space8}>
      <Text textType={TextType.H3} value={messages.chooseTitle} />
      {shouldShowForcedMfaContext ? (
        <Text style={{ marginBottom: '16px' }} textType={TextType.H4} value={messages.forcedMfaFlowContext} />
      ) : null}
      <Text
        textType={TextType.Paragraph}
        value={shouldShowForcedMfaContext ? messages.forcedMfaChooseSubheader : messages.chooseSubheader}
      />
      {error ? <ErrorBanner code={error.code} message={error.message} /> : null}
      <RadioCheckList>
        {enrollments.map((enrollment) => {
          return (
            <RadioCheckListItem
              key={enrollment.id}
              id={enrollment.id}
              isChecked={selectedEnrollmentId === enrollment.id}
              onChecked={() => setSelectEnrollmentId(enrollment.id)}
              value={enrollment.id}
            >
              {getDisplayForFactor(enrollment)}
            </RadioCheckListItem>
          );
        })}
      </RadioCheckList>
      {shouldShowForcedMfaContext ? <Text textType={TextType.Paragraph} value={messages.securityExplanation} /> : null}
    </FlexColumn>
  );
};
